// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1649":"23ef32650e96d33d6586","5802":"36a9971f58c808c4a974","8764":"58763b7a689318950e51"}[chunkId] + ".js";
};